/* Velorution cart drawer.
   Every add-to-cart on the site goes through here: post to /cart/add.js, ask
   Shopify to re-render the drawer section in the same round trip, swap it in,
   open it. One request, server-rendered money, no client-side templating.

   Everything degrades: if this file fails to load, or JS is off, the same
   forms post normally and land on /cart, which carries the same back-issue
   strip and the same checkout button. */
(function () {
  'use strict';

  var SECTION = 'velo-cart-drawer';
  var wrap = document.getElementById('shopify-section-' + SECTION);
  if (!wrap) return;

  var lastOpener = null;

  function drawer() { return wrap.querySelector('[data-cart-drawer]'); }

  function open(opener) {
    var d = drawer();
    if (!d) return;
    lastOpener = opener || null;
    d.hidden = false;
    document.documentElement.classList.add('vcd-open');
    /* Read a layout property to flush the closed state, then set the open one
       synchronously. requestAnimationFrame was doing this job and doesn't fire
       reliably when the tab isn't painting — the drawer then arrived unhidden
       but still translated off-screen, which looks exactly like nothing
       happening. Forcing the reflow gives the transition its start state
       without depending on a frame ever being drawn. */
    void d.offsetWidth;
    d.classList.add('is-open');
    var x = d.querySelector('[data-cart-close]');
    if (x && x.focus) x.focus();
  }

  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('vcd-open');
    // Match the CSS transition rather than guessing: 260ms there, 260ms here.
    setTimeout(function () { if (d) d.hidden = true; }, 260);
    if (lastOpener && lastOpener.focus) lastOpener.focus();
    lastOpener = null;
  }

  function isOpen() {
    var d = drawer();
    return d && !d.hidden;
  }

  /* Swap in freshly rendered markup and update the header count. The response
     from Shopify is a full <div id="shopify-section-…"> string, so it is parsed
     and only its innards are transplanted — replacing the wrapper itself would
     lose the element this whole module holds a reference to. */
  function paint(html, count) {
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + SECTION);
      wrap.innerHTML = fresh ? fresh.innerHTML : html;
    }
    if (typeof count === 'number') {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        /* The button is rendered hidden on a page that loaded with an empty
           cart, so adding the first item has to reveal it here — otherwise the
           drawer closes onto a header with no way back into it. */
        var btn = el.closest('[data-cart-link]');
        if (btn) {
          btn.classList.toggle('is-empty', count === 0);
          btn.hidden = count === 0;
        }
      });
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function sectionsPayload() {
    return { sections: SECTION, sections_url: window.location.pathname };
  }

  /* ————— Adding ————— */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form');
    if (!form) return;

    var action = form.getAttribute('action') || '';
    var isAdd = form.hasAttribute('data-tvp-form') || action.indexOf('/cart/add') !== -1;
    if (!isAdd) return;

    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }

    var fd = new FormData(form);
    var body = sectionsPayload();
    body.items = [{
      id: Number(fd.get('id')),
      quantity: Number(fd.get('quantity') || 1)
    }];
    /* The chosen card wins over anything named selling_plan in the form: Seal
       overwrites that field with its own value and would quietly bill monthly
       for someone who picked yearly. Falls back to the field for the gift page
       and for any form without plan cards. */
    var picked = form.querySelector('[name="velo_plan"]:checked') ||
                 form.querySelector('select[name="velo_plan"]');
    if (picked && picked.tagName === 'SELECT') picked = picked.options[picked.selectedIndex];
    var planId = (picked && picked.dataset.sellingPlan) || fd.get('selling_plan');
    if (planId) body.items[0].selling_plan = Number(planId);

    var props = {};
    fd.forEach(function (val, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && String(val).trim() !== '') props[m[1]] = val;
    });
    if (Object.keys(props).length) body.items[0].properties = props;

    post('/cart/add.js', body)
      .then(function (data) {
        paint(data.sections && data.sections[SECTION], null);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        paint(null, cart.item_count);
        open(btn);
      })
      .catch(function (err) {
        /* Almost always "sold out" on a back issue — the stock counts on this
           page are real, so this is a case that will genuinely happen. Say what
           went wrong next to the button rather than in an alert. */
        var msg = (err && (err.description || err.message)) || 'Sorry — that could not be added.';
        var slot = form.querySelector('[data-tvp-error]');
        if (!slot) {
          slot = document.createElement('p');
          slot.className = 'tvp-err';
          slot.setAttribute('data-tvp-error', '');
          form.appendChild(slot);
        }
        slot.textContent = msg;
      })
      .then(function () {
        if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; }
      });
  });

  /* ————— Quantity and removal, inside the drawer ————— */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (q) {
      e.preventDefault();
      var panel = q.closest('[data-cart-drawer]');
      if (panel) panel.classList.add('is-busy');
      post('/cart/change.js', Object.assign({
        line: Number(q.getAttribute('data-cart-qty')),
        quantity: Number(q.getAttribute('data-to'))
      }, sectionsPayload()))
        .then(function (cart) {
          paint(cart.sections && cart.sections[SECTION], cart.item_count);
          var d = drawer();
          if (d) { d.hidden = false; d.classList.add('is-open'); }
        })
        .catch(function () { window.location.href = '/cart'; });
      return;
    }

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(e.target.closest('[data-cart-open]')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });
})();
